import React from "react";
import { getInsurance } from "requests/Insurance";
import { formattedInsuranceNumber } from "shared/helper";

import { ILabelValue } from "shared/types/index";

const useInsurance = () => {
  const [insurance, setInsurance] = React.useState<ILabelValue[]>([]);

  const handleInsurance = React.useCallback(async () => {
    const { status, data } = await getInsurance();

    if ([200, 201].includes(status)) {
      const values: ILabelValue[] = [];

      data.forEach((state) =>
        values.push({
          label: `${formattedInsuranceNumber(state.PLN_ANS)} - ${
            state.PLN_SIGLA
          } - ${state.PLN_NOME}`,
          value: state.PLN_ID,
        })
      );
      setInsurance(values);
    }
  }, []);

  React.useEffect(() => {
    handleInsurance();
  }, [handleInsurance]);

  return {
    insurance,
  };
};

export { useInsurance };
